import { Button } from 'components'
import Flex from 'components/priority/Flex/Flex'
import { useRecoilValue } from 'recoil'
import {
  editorClipboardAtom,
  itemsLockedAtom,
  selectedItemAtom,
  selectedItemsAtom,
} from 'atoms'
import { useCopyItemToClipboard, usePasteItemFromClipboard } from 'hooks'
import { useCopyMultiItemsToClipboard } from 'hooks/editor/useCopyMultipleItemsToClipboard'
import { usePasteMultipleItemsFromClipboard } from 'hooks/editor/usePasteMultipleItemsFromClipboard'
import { useTranslation } from 'react-i18next'

export const Clipboard = ({ padding, justify }) => {
  const selectedItems = useRecoilValue(selectedItemsAtom)
  const selectedItem = useRecoilValue(selectedItemAtom)
  const clipboard = useRecoilValue(editorClipboardAtom)
  const itemsLocked = useRecoilValue(itemsLockedAtom)
  const { t } = useTranslation()
  const copyItemToClipboard = useCopyItemToClipboard()
  const pasteItemFromClipBoard = usePasteItemFromClipboard()
  const copyMultiItemsToClipboard = useCopyMultiItemsToClipboard()
  const pasteMultiItemsFromClipBoard = usePasteMultipleItemsFromClipboard()

  const hasSelectedMultipleItems = selectedItems.length > 0
  const isClipboardEmpty = clipboard.length === 0
  const hasClipboardMultipleItems = clipboard.length > 1

  if (!hasSelectedMultipleItems && !selectedItem && isClipboardEmpty)
    return null

  const copy = () => {
    if (hasSelectedMultipleItems) {
      copyMultiItemsToClipboard()
    } else if (selectedItem) {
      copyItemToClipboard()
    }
  }

  const paste = () => {
    if (hasClipboardMultipleItems) {
      pasteMultiItemsFromClipBoard()
    } else {
      pasteItemFromClipBoard()
    }
  }

  return (
    <Flex full margin="0 0 24px" justify={justify} padding={padding}>
      {(hasSelectedMultipleItems || selectedItem) && (
        <Button
          center
          full={isClipboardEmpty}
          onClick={copy}
          disabled={itemsLocked}
          data-testid="clipboard-copy"
        >
          {`${hasSelectedMultipleItems ? t('editor.menus.properties.elements.clipboard.copyItemsButton') : t('editor.menus.properties.elements.clipboard.copyItemButton')}`}
        </Button>
      )}
      {!isClipboardEmpty && (
        <Button
          full
          center
          margin="0 0 0 12px"
          onClick={() => paste()}
          disabled={itemsLocked}
          data-testid="clipboard-paste"
        >
          {`${hasClipboardMultipleItems ? t('editor.menus.properties.elements.clipboard.pasteItemsButton') : t('editor.menus.properties.elements.clipboard.pasteItemButton')}`}
        </Button>
      )}
    </Flex>
  )
}

export default Clipboard
